import React from 'react';
import { UserDashboardLayout } from './UserDashboardLayout';
import { LeaveApproval } from '../attendance';
import { useAuthStore } from '../auth/authStore';

const ManagerLeaveApproval: React.FC = () => {
  const { user } = useAuthStore();
  
  // Determine user role for approval interface
  const userRole = user?.roles?.includes('FirmAdmin') ? 'FIRM_ADMIN' : 'MANAGER';

  return (
    <UserDashboardLayout>
      <div className="p-6">
        <LeaveApproval userRole={userRole} />
      </div>
    </UserDashboardLayout>
  );
};

export default ManagerLeaveApproval;
